import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-866aff4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col bg-gray-300" }
const _hoisted_2 = { class: "flex flex-col min-h-screen" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "tp-hero" }, null, -1))
const _hoisted_4 = { class: "main w-full items-stretch" }
const _hoisted_5 = { class: "fixed inset-x-0 bottom-0 top-auto z-navigation flex flex-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "tp-overlay",
  class: "z-overlay"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "tp-navigation",
  class: "z-navigation"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_SiteLayout = _resolveComponent("SiteLayout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BusinessComponent = _resolveComponent("BusinessComponent")!
  const _component_ApiMessages = _resolveComponent("ApiMessages")!
  const _component_AgentsInfoBar = _resolveComponent("AgentsInfoBar")!
  const _component_CustomerServiceBar = _resolveComponent("CustomerServiceBar")!
  const _component_DialogHost = _resolveComponent("DialogHost")!
  const _component_FreightInfoDialog = _resolveComponent("FreightInfoDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["transition-opacity duration-2000", { 'opacity-50': _ctx.pending }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageHeader),
        _hoisted_3,
        (_ctx.shouldShowContent)
          ? (_openBlock(), _createBlock(_component_SiteLayout, { key: 0 }, {
              Full: _withCtx(() => [
                _createVNode(_component_Breadcrumb)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("main", _hoisted_4, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.shouldShowContent]
        ]),
        _createVNode(_component_SiteLayout, null, {
          "Full,Checkout": _withCtx(() => [
            _createVNode(_component_BusinessComponent, { name: "PageFooter" })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ApiMessages),
          _createVNode(_component_AgentsInfoBar),
          _createVNode(_component_CustomerServiceBar)
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    _createVNode(_component_DialogHost),
    _createVNode(_component_BusinessComponent, { name: "ProductWishlist" }),
    _createVNode(_component_FreightInfoDialog)
  ], 2))
}